import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1 text-xs font-semibold text-[#202A35]/60">
      {items.map((c, i) => (
        <li key={c.path} className="inline-flex items-center gap-1">
          {i > 0 && <ChevronRight size={12} aria-hidden="true" />}
          {i === items.length - 1
            ? <span aria-current="page" className="text-[#202A35] line-clamp-1" data-testid="breadcrumb-current">{c.name}</span>
            : <Link to={c.path} className="hover:text-[#202A35] hover:underline" data-testid={`breadcrumb-${i}`}>{c.name}</Link>}
        </li>
      ))}
    </ol>
  </nav>
);
